import { render, staticRenderFns } from "./FormRadioGroup.vue?vue&type=template&id=3d2bbc0c&scoped=true&"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormRadioGroup.vue?vue&type=style&index=0&id=3d2bbc0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2bbc0c",
  null
  
)

export default component.exports